import { useContext, useEffect, useState } from "react";
import {
  getRolesByTenant,
  createRoles,
  updateRoles,
  deleteRoles,
  reactiveRoles,
} from "../services/console/roles";
import { AppContext } from "../context";

type UseType = "DATA" | "ACTIONS";
export type ActionType = "CREATE" | "UPDATE" | "DELETE" | "REACTIVE";

const handleRolesFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createRoles,
        fnMsg: t("Roles.rolesApiCreateLabel"),
      };
    case "UPDATE":
      return {
        actionFn: updateRoles,
        fnMsg: t("Roles.rolesApiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: deleteRoles,
        fnMsg: t("Roles.rolesApiDeleteLabel"),
      };
    case "REACTIVE":
      return {
        actionFn: reactiveRoles,
        fnMsg: t("Roles.rolesApiReactiveLabel"),
      };
    default:
      return {
        actionFn: () => { },
        fnMsg: "",
      };
  }
};

export const useRoles = (type: UseType, catalogId?: number, filterTenantId?: string) => {
  const { t, toast, setAppState, appState: { tenantId, selectedTenantId } } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const rolesAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleRolesFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg.replace('{name}', data?.name)}`,
          life: 3000,
        });
        setAppState((prev) => ({
          ...prev,
          refreshRolePermissions: !prev.refreshRolePermissions,
        }));
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: (
            !!error?.response?.data?.header?.errorMsg &&
            error?.response?.data?.header?.errorMsg !== "Error: 500"
          )
            ? error?.response?.data?.header?.errorMsg
            : t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getRolesByTenant(filterTenantId ? filterTenantId : (selectedTenantId! || tenantId)))
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: (
                !!error?.response?.data?.header?.errorMsg &&
                error?.response?.data?.header?.errorMsg !== "Error: 500"
              )
                ? error?.response?.data?.header?.errorMsg
                : t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [toast, reload, type, catalogId]);

  return {
    data,
    rolesAction,
    reloadFn,
  };
};
